import { render, staticRenderFns } from "./educations.vue?vue&type=template&id=f211e112&"
import script from "./educations.vue?vue&type=script&lang=js&"
export * from "./educations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports